import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Use a more descriptive name, like 'currentUser' or 'userProfile'
  user: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // A more concise and descriptive action name
    setUser: (state, action) => {
      // The payload name can be changed if it represents a specific object, like 'userPayload'
      state.user = action.payload;
      console.log('User details updated:', action.payload);
    },
     clearUser: (state) => {
     state.user = null;
     }
  },
});

// Action creators are now generated for the new reducer names
export const { setUser, clearUser } = userSlice.actions;

// The default export remains the same
export default userSlice.reducer;